module.exports = __webpack_public_path__ + "static/media/section1-image3.39717fa7.webp";